export default __webpack_public_path__ + "static/media/8.17a1d522.webp";